import { createReducer } from '@reduxjs/toolkit';

import { loadAccountDetailsSuccess, loadAccountsStart, resetAccountDetails } from './actions';
import { IMerchantAccountsReducer } from './types';

const initialState: IMerchantAccountsReducer = {
  isLoading: false,
  isLoaded: false,
  details: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadAccountsStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadAccountDetailsSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, details: action.payload }))
    .addCase(resetAccountDetails, (state) => initialState);
});
